import React, { useState, useRef, useEffect } from 'react';
import config from '../../config';
import { InputNumber } from 'primereact/inputnumber';

const Tenthouseaccordian = ({ serviceData, onNext }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [addedItems, setAddedItems] = useState([]);
  const [currentIndexes, setCurrentIndexes] = useState({});
  const [imageLoading, setImageLoading] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [dataLoading, setDataLoading] = useState(true);


   const hasAddedItems = addedItems.some(item => item.checked && item.count > 0);
  // Simulate data loading
  useEffect(() => {
    if (serviceData && serviceData.length > 0) {
      setDataLoading(false);
    }
  }, [serviceData]);

  const handleNextImage = (service) => {
    setImageLoading((prev) => ({ ...prev, [service.id]: true }));
    setCurrentIndexes((prev) => ({
      ...prev,
      [service.id]:
        prev[service.id] === undefined
          ? 1
          : (prev[service.id] + 1) % service.gallery.length,
    }));
  };

  const handlePrev = (service) => {
    setImageLoading((prev) => ({ ...prev, [service.id]: true }));
    setCurrentIndexes((prev) => ({
      ...prev,
      [service.id]:
        prev[service.id] === undefined || prev[service.id] === 0
          ? service.gallery.length - 1
          : prev[service.id] - 1,
    }));
  };

  const handleCheckboxChange = (service, checked) => {
    setAddedItems((prev) => {
      const exists = prev.find((item) => item.id === service.id);
      if (exists) {
        return prev.map((item) =>
          item.id === service.id
            ? { ...item, checked, count: checked ? item.count || 1 : 0 }
            : item
        );
      } else {
        return [...prev, { ...service, checked, count: 1 }];
      }
    });
  };

  const MAX_COUNT = 99999;

  const handleCountChange = (serviceId, count) => {
    const safeCount = Math.min(count, MAX_COUNT);
    setAddedItems((prev) => {
      const exists = prev.find((item) => item.id === serviceId);
      if (exists) {
        return prev.map((item) =>
          item.id === serviceId
            ? { ...item, count: safeCount, checked: safeCount > 0 }
            : item
        );
      } else {
        const service = serviceData
          .flatMap((cat) => cat.services)
          .find((s) => s.id === serviceId);
        if (!service) return prev;
        return [...prev, { ...service, count: safeCount, checked: safeCount > 0 }];
      }
    });
  };

  const handleNext = () => {
    const filtered = addedItems
      .filter((item) => item.checked && item.count > 0)
      .map((item) => ({
        service_name: item.service_name,
        count: item.count,
        id: item.id,
      }));

    console.log("Selected Services:", filtered);
    if (onNext) {
      onNext(filtered);
    }
  };

  

  const filteredServiceData = serviceData
    ?.map((category) => ({
      ...category,
      services: category.services.filter((service) =>
        service.service_name.toLowerCase().includes(searchTerm)
      ),
    }))
    .filter((category) => category.services.length > 0) || [];

  // Get first image from category for display
  const getCategoryImage = (category) => {
    const firstService = category.services?.[0];
    return firstService?.gallery?.[0];
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const handleBackToCategories = () => {
    setSelectedCategory(null);
  };

  // Show loading spinner while data is loading
  if (dataLoading) {
    return (
      <div className="_tentpopuplist_categories_container">
        <h3 style={{ textAlign: "center" }}>
          <i
            className="pi pi-spin pi-spinner-dotted"
            style={{ fontSize: "2rem", color: "#0cc0df" }}
          ></i>
        </h3>
      </div>
    );
  }

  return (
    <div className="_tentpopuplist_categories_container">
      <div className="_tentpopuplist_search_container">
        <input
          type="text"
          placeholder="Search Items..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
          className="_tentpopuplist_search_input"
        />
      </div>

      {!selectedCategory ? (
        // Categories Grid View
        <div className="_tentpopuplist_categories_grid_container">
          <h3 className="_tentpopuplist_categories_title"> Select Items </h3>
          {filteredServiceData.length === 0 ? (
            <p className="_tentpopuplist_no_data">No categories available</p>
          ) : (
            <div className="_tentpopuplist_categories_grid">
              {filteredServiceData.map((category) => {
                const firstImage = getCategoryImage(category);
                const categoryImageLoading = !firstImage?.id;
                
                return (
                  <div 
                    key={category.id} 
                    className="_tentpopuplist_category_card"
                    onClick={() => handleCategorySelect(category)}
                  >
                    <div className="_tentpopuplist_category_image_container">
                      {categoryImageLoading ? (
                        <h3 className="_tentpopuplist_loading_spinner">
                          <i
                            className="pi pi-spin pi-spinner-dotted"
                            style={{ fontSize: "2rem", color: "#0cc0df" }}
                          ></i>
                        </h3>
                      ) : firstImage?.id ? (
                        <img 
                          src={`${config.API_BASE_URL}/gallery/download/${firstImage.id}`} 
                          alt={category.name}
                          className="_tentpopuplist_category_image"
                          onLoad={() => setImageLoading((prev) => ({ ...prev, [category.id]: false }))}
                          onError={() => setImageLoading((prev) => ({ ...prev, [category.id]: false }))}
                        />
                      ) : (
                        <div className="_tentpopuplist_no_image_available">
                          No Image Available
                        </div>
                      )}
                    </div>
                    <div className="_tentpopuplist_category_name">{category.name}</div>
                    {/* <button className="_tentpopuplist_category_select_btn">
                      Select
                    </button> */}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ) : (
        // Services Grid View for Selected Category
        <div className="_tentpopuplist_services_view_container">
          <div className="_tentpopuplist_services_view_header">
            <button 
              className="_tentpopuplist_back_button"
              onClick={handleBackToCategories}
            >
              <span className='pi pi-arrow-left'></span>
            </button>
            <h3 className="_tentpopuplist_services_title">{selectedCategory.name} - Services</h3>
          </div>

          <div className="_tentpopuplist_services_grid_container">
            {selectedCategory.services.length === 0 ? (
              <p className="_tentpopuplist_no_data">No services available in this category</p>
            ) : (
              <div className="_tentpopuplist_services_grid">
                {selectedCategory.services.map((service) => {
                  const selected = addedItems.find((item) => item.id === service.id);

                  const currentIndex =
                    typeof currentIndexes[service.id] === "number" ? currentIndexes[service.id] : 0;

                  const currentImage =
                    service.gallery && service.gallery.length > 0
                      ? service.gallery[currentIndex]
                      : null;

                  const loading = typeof imageLoading[service.id] === "boolean" ? imageLoading[service.id] : true;

                  const hasMultipleImages = service.gallery && service.gallery.length > 1;

                  return (
                    <div className='_tentpopuplist_service_grid_item' key={service.id}>
                      <div className="_tentpopuplist_service_image_container">
                        {/* Loader */}
                        {loading && (
                          <div className="_tentpopuplist_image_loader">
                            <h3 className="_tentpopuplist_loading_spinner">
                              <i
                                className="pi pi-spin pi-spinner-dotted"
                                style={{ fontSize: "2rem", color: "#0cc0df" }}
                              ></i>
                            </h3>
                          </div>
                        )}

                        {/* Image */}
                        {currentImage?.id ? (
                          <img
                            src={`${config.API_BASE_URL}/gallery/download/${currentImage.id}`}
                            alt="Service"
                            onLoad={() => setImageLoading((prev) => ({ ...prev, [service.id]: false }))}
                            onError={() => setImageLoading((prev) => ({ ...prev, [service.id]: false }))}
                            style={{ display: loading ? "none" : "block" }}
                          />
                        ) : (
                          <div className="_tentpopuplist_no_image_available">
                            No Image Available
                          </div>
                        )}

                        {/* Navigation Arrows */}
                        {hasMultipleImages && currentImage?.id && (
                          <>
                            <button
                              onClick={(e) => { 
                                e.stopPropagation();
                                handlePrev(service); 
                              }}
                              className="_tentpopuplist_nav_arrow _tentpopuplist_left_arrow"
                              disabled={loading}
                            >
                              ‹
                            </button>

                            <button
                              onClick={(e) => { 
                                e.stopPropagation();
                                handleNextImage(service);
                              }}
                              className="_tentpopuplist_nav_arrow _tentpopuplist_right_arrow"
                              disabled={loading}
                            >
                              ›
                            </button>
                          </>
                        )}

                        {/* Image Counter */}
                        {hasMultipleImages && currentImage?.id && (
                          <div className="_tentpopuplist_image_counter">
                            {currentIndex + 1} / {service.gallery.length}
                          </div>
                        )}
                      </div>

                      <div className="_tentpopuplist_service_item">                    
                        <div className='_tentpopuplist_service_item_label_wrapper'>
                          <label>{service.service_name}</label>
                        </div>

                        <div className="_tentpopuplist_service_counter_wrapper">
                          <div className="_tentpopuplist_counter_box">
                            <button
                              className="_tentpopuplist_counter_btn"
                              onClick={() => handleCountChange(service.id, Math.max(0, (selected?.count || 0) - 1))}
                              disabled={!selected || selected.count <= 0}
                            >
                              −
                            </button>
                            <input
                              type="number"
                              className="_tentpopuplist_counter_value"
                              value={selected?.count || 0}
                              onChange={(e) => {
                                const newValue = Math.min(Math.max(0, Number(e.target.value) || 0), 1000);
                                handleCountChange(service.id, newValue);
                              }}
                              min={0}
                              max={1000}
                            />
                            <button
                              className="_tentpopuplist_counter_btn"
                              onClick={() => handleCountChange(service.id, (selected?.count || 0) + 1)}
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}

      <div className="_tentpopuplist_next_button_container">
        
        <button 
        className={`_tentpopuplist_custom_button _tentpopuplist_save_button ${!hasAddedItems ? '_tentpopuplist_button_disabled' : ''}`} 
         onClick={handleNext}
         disabled={!hasAddedItems}
         >
          Next
        </button>
        
      </div>
    </div>
  );
};

export default Tenthouseaccordian;